'use client';

import React, { useEffect, useState } from 'react';

import { usePathname } from 'next/navigation';

import CustomIcon from '@components/utils/CustomIcon';
import { useBasketId } from '@hooks/cache';
import useBasketInformation from '@hooks/useBasketInformation';
import { PaymentRequestChannelType } from '@api/index';
import STATIC_ROUTES from '@data/staticRoutes.json';
import { Shopping } from '@assets/icons';

import {
  BasketIconBadge,
  BasketIconWrapper,
  StyledLink,
} from './BasketLinkStyle';

const BasketLink = () => {
  const pathname = usePathname();
  const basketId = useBasketId();

  const [basketLink, setBasketLink] = useState('/seyahat-planlama');

  useEffect(() => {
    if (basketId) {
      setBasketLink(`/seyahat-planlama?bid=${basketId}`);
    }
  }, [basketId]);

  const { itemsInBasket } = useBasketInformation(
    basketId ?? '',
    PaymentRequestChannelType.SHOP_AND_FLY_WEB
  );

  const excludedPaths = [STATIC_ROUTES.reservationSummary];

  if (pathname && excludedPaths.includes(pathname)) {
    return null;
  }

  return (
    <StyledLink prefetch={false} href={basketLink}>
      <BasketIconWrapper>
        {itemsInBasket ? <BasketIconBadge /> : null}
        <CustomIcon
          fontSize={20}
          icon={Shopping}
          paletteColor='whiteAlpha600'
        />
      </BasketIconWrapper>
    </StyledLink>
  );
};

export default BasketLink;
